import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout as logoutUser, fetchUserActivity } from "../../store/userSlice";
import { logout as logoutHospital } from "../../store/hospitalSlice";

const formatTimeAgo = (value) => {
  if (!value) return "Just now";
  const ms = Date.now() - new Date(value).getTime();
  const min = Math.floor(ms / 60000);
  if (min < 1) return "Just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hour${hr > 1 ? "s" : ""} ago`;
  const day = Math.floor(hr / 24);
  return `${day} day${day > 1 ? "s" : ""} ago`;
};

const UserSidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.user.userInfo);
  const activities = useSelector((state) => state.user.activities);

  useEffect(() => {
    if (userInfo) {
      dispatch(fetchUserActivity());
    }
  }, [dispatch, userInfo]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logoutUser());
    dispatch(logoutHospital());
    navigate("/login");
  };

  return (
    <div className="col-lg-3">
      <div className="dashboard-sidebar">
        <div className="single-widget mb-60">
          <div className="dashboard-menu">
            <ul>
              <li>
                <NavLink to="/user-dashboard">Dashboard</NavLink>
              </li>
              <li>
                <NavLink to="/user-profile">My Profile</NavLink>
              </li>
              <li>
                <NavLink to="/applied-jobs">Applied Jobs</NavLink>
              </li>
              <li>
                <NavLink to="/bookmark">Bookmark Jobs</NavLink>
              </li>
              <li>
                <NavLink to="/user-setting">Settings</NavLink>
              </li>
              <li>
                <a href="/logout" onClick={handleLogout}>
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="single-widget">
          <div className="widget-title">
            <h6>{userInfo?.userDocument?.firstName || "User"} Activity:</h6>
          </div>
          <ul className="recent-activitys">
            {activities.length === 0 ? (
              <li>
                <div className="content">
                  <h6>No recent activity yet.</h6>
                </div>
              </li>
            ) : (
              activities.map((item) => (
                <li key={item._id}>
                  <div className="content">
                    <h6>{item.action}</h6>
                    <p>{item.details}</p>
                    <span>
                      <img src="/assets/images/icon/clock-1.svg" alt="" />{" "}
                      {formatTimeAgo(item.createdAt)}
                    </span>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserSidebar;
